import { useEffect, useState } from 'react'
import { Row, Col, Space } from 'antd'

import _find from 'lodash/find'
import _isEmpty from 'lodash/isEmpty'
import _map from 'lodash/map'

import Collapse from 'components/Collapse'
import Paragraph from 'components/Paragraph'
import Title from 'components/Title'
import Image from 'components/Image'

import Styled from './styled'

export default function Faq({ data }) {
  const [activeCategoryId, setActiveCategoryId] = useState(null)

  const categories = data?.categories
  const title = data?.title
  const subTitle = data?.subTitle

  const activeCategory = _find(categories, ['id', activeCategoryId])
  const activeTitle = activeCategory?.title
  const activeContents = activeCategory?.contents

  useEffect(() => {
    if (!_isEmpty(categories)) {
      setActiveCategoryId(categories?.[0]?.id)
    }
  }, [data])

  return (
    <Styled>
      <div className="content-faq-page">
        <div className="container">
          <div className="title-block">
            <Title level={1}>{title}</Title>
          </div>

          <div className="sub-title-block">
            <Title level={3}>{subTitle}</Title>
          </div>

          <Row
            gutter={[
              { xs: 14, md: 12, lg: 20 },
              { xs: 14, md: 12, lg: 20 },
            ]}
          >
            {_map(categories, category => {
              const id = category?.id
              const name = category?.title
              const imageIcon = category?.imageIcon?.url

              return (
                <Col span={6} xs={12} md={6} key={id}>
                  <div className="category-block" onClick={() => setActiveCategoryId(id)}>
                    <Space direction="vertical" size={16}>
                      <Image src={imageIcon} className="icon" />

                      <Title level={5} className="text-category-name">
                        {name}
                      </Title>
                    </Space>
                  </div>
                </Col>
              )
            })}
          </Row>

          <div className="faq-content">
            <div className="title-faq">
              <Title level={3} medium className="text-title-faq">
                {activeTitle}
              </Title>
            </div>

            <Collapse
              items={_map(activeContents, item => {
                return {
                  headerLabel: item?.question,
                  uiRenderer: <Paragraph>{item?.answer}</Paragraph>,
                }
              })}
            />
          </div>
        </div>
      </div>
    </Styled>
  )
}
